.retry-button {
  padding-left: 5px;
}
